import { produce } from 'immer'
import type { State } from '../typings'

export type SetResultsPageAction = { type: 'setResultsPage'; payload: number }

export const setResultsPageAction = (
  state: State,
  payload: SetResultsPageAction['payload'],
) =>
  produce(state, (draft) => {
    draft.page = payload
  })

export const setResultsPageActionCreator = (
  payload: SetResultsPageAction['payload'],
): SetResultsPageAction => ({ type: 'setResultsPage', payload })
